// getters是给vuex的mapGetters使用的


export default {
  logged: state => state.logged,
  ac: state => state.ac,
  working: state => state.working,
  defines: state => state.defines
}